import { Badge } from "@veil/ui/components/badge";

const VARIANT_FOR_STATUS = {
	running: "warning",
	succeeded: "success",
	failed: "destructive",
	cancelled: "secondary",
} as const;

type Status = keyof typeof VARIANT_FOR_STATUS;

export function StatusBadge({ status }: { status: string }) {
	const variant =
		(
			VARIANT_FOR_STATUS as Record<
				string,
				"warning" | "success" | "destructive" | "secondary"
			>
		)[status] ?? "secondary";
	return (
		<Badge variant={variant} className="capitalize">
			{status}
		</Badge>
	);
}

export type { Status };
